import { Box } from '@mui/system';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { AUDITS_METADATA } from '@utils/audits';
import React from 'react';
import AuditActionTypeChip from '../Chip/AuditActionTypeChip';

const AuditActionStatusCell: React.FC<GridRenderCellParams<string>> = ({
	value
}) => {
	const type = AUDITS_METADATA[value!]?.type;

	return (
		<Box display="flex" flexGrow={1}>
			<AuditActionTypeChip actionType={type} />
		</Box>
	);
};

export default AuditActionStatusCell;
